import { LAUNCH } from './launch';

/**
 * What someone hears when they try to sign in with no account before Deck opens. The sentence is what
 * the server sends; the sign-in pages recognise it and show the notice instead.
 */
export const NOT_OPEN_YET = `Deck opens for new accounts on ${LAUNCH.label}. Press Get started on the home page, and your invite will be in your inbox that morning.`;

export const NOT_OPEN_YET_NOTICE = {
  title: `Deck opens on ${LAUNCH.label}.`,
  body: "There's no Deck account for this email yet. Get started now, and your invite will be in your inbox that morning.",
  action: 'Get started',
  // The home page with the start flow already open.
  href: '/?start',
};
